import Stack from '@mui/material/Stack';
import React from 'react';
import DynamicBreadcrumbs, { type BreadcrumbItem } from './Breadcrumb/DynamicBreadcrumb';

interface HeaderProps {
  children?: React.ReactNode | null;
  breadcrumbItems?: BreadcrumbItem[];
}

const Header: React.FC<HeaderProps> = ({ children, breadcrumbItems }) => {
  return (
    <Stack direction="row" sx={headerStackStyles} spacing={2}>
      <DynamicBreadcrumbs breadcrumbItems={breadcrumbItems} />
      <Stack direction="row" sx={childrenStackStyles}>
        {children}
      </Stack>
    </Stack>
  );
};

const headerStackStyles = {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  paddingTop: 4.5,
  height: '93px',
  paddingBottom: '26px',
};

const childrenStackStyles = {
  gap: 1,
};

export default Header;
